import { useEffect, useRef, useState } from "react";
import LeasedOwnedTaskStepper from "./LeasedOwnedTaskStepper";
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import CommentBee from "../../../../assets/images/PenndingApproval/Comment Bee.png";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import navOperations from "redux/Navigation/operations";
import { setTransferData } from "Store/OrderManagement/FleetProcessing/FleetProcessingAction";
import userProfileSelectors from "redux/UserProfile/selectors"
import { getSaveFleetDisposition, setSaveFleetDisposition } from "Store/FleetManagement/FleetDispositionSave/FleetDispositionSaveAction";
import { CONSTANTS } from "client/utils/constants";
import permissions, { isAuthorized } from "client/utils/Permissions";
import { setSavedStatus } from "Store/FleetManagement/FleetAdminTask/AdminTaskAction";
import { getAfeFleetItemCancel, getAssetFleetItemCancel } from "Store/FleetManagement/FleetItemCancel/FleetItemCancelAction";
import { formatPriceWithSign, getOnlyNumbersWithSign, popupInitialData } from "utils";
import moment from "moment";
import { saveDispositionPayment, setDispositionPaymentData } from "Store/FleetManagement/FleetDispositionPaymentSave/FleetDispositionPaymentSaveAction";
import { setFleetItemId } from "Store/AssetManagement/AssetNumber/AssetNumberAction";
import { getFleetAssetChangeLog } from "Store/FleetManagement/FleetAssetChangeLog/FleetAssetChangeLogAction";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";
import { getAfeFleetItemReturnToRequestor, getAssetFleetItemReturnToRequestor } from "Store/FleetManagement/FleetItemReturnToRequestor/FleetItemReturnToRequestorAction";

const LeasedOwnedTaskStepperContainer = (props:any) => {
  const { setIsChnagedOccuredFlag, showPaymentInformation, validatePaymentInfo, setValidatePaymentInfo} = props

    const dispatch = useDispatch();
    const dispatchNav = navOperations.dispatchNav(dispatch);
    const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch);

    const navigate = useNavigate();
    const setAssignedToError = props?.setAssignedToError;
    const assignedToError = props?.assignedToError
    const newAssetError = props?.newAssetError
    const setNewAssetError  = props?.setNewAssetError
    const setNewAssetValue = props?.setNewAssetValue
    const attachmentChangeFleetId = props?.attachmentChangeFleetId
    const setAttachmentChangeFleetId = props?.setAttachmentChangeFleetId
    const requestFleetAssetDetails = props?.requestFleetAssetDetails
    const setAssetDeterminationValue = props?.setAssetDeterminationValue
    const assetDeterminationValue = props?.assetDeterminationValue
    const newAssetValue = props?.newAssetValue
    const assetDetails = props?.item
    const setCancelComments = props?.setCancelComments;
    const StepperRef = useRef<any>(null);
  
    const [assignedToDropdownList, setAssignedToDropdownList] = useState([]);
    const [assignedToValue, setAssignedToValue] = useState<any>(null);
    const [error, setError] = useState<any>({});
    const [dispositionPayment, setDispositionPayment] = useState<any>({})
    const [dispositionTitle, setDispositionTitle] = useState<any>({})
    const [titleExists,setTitleExists] = useState<any>({});
    const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);

    const {
      transferData,
      userDetails,
      savedStatus,
      fleetDispositionValue,
      assignTo,
      dispositionPaymentData,
      assetOrderHeaderDetail
  }: any = useSelector((state?: any) => ({
      transferData: state.FleetProcessingReducer.transferData,
      userDetails: userProfileSelectors.getUserDetails(state),
      savedStatus: state.adminTaskReducer.savedStatus,
      fleetDispositionValue : state.FleetDispositionSaveReducer.fleetDispositionValue,
      assignTo: state.PurchaseOrder.assignTo,
      dispositionPaymentData: state.FleetDispositionPaymentReducer.dispositionPaymentData,
      assetOrderHeaderDetail: state.AssetFleetProcessingReducer.assetOrderHeaderDetail
  }));

  useEffect(()=>{
    if(showPaymentInformation){
      setDispositionPayment({
        isCheck: assetDetails?.dispositionPayment?.isCheck,
        checkOrWireNo: assetDetails?.dispositionPayment?.checkOrWireNo ? assetDetails?.dispositionPayment?.checkOrWireNo : '',
        buyerName: assetDetails?.dispositionPayment?.buyerName,
        totalCheckOrWireAmount: (assetDetails?.dispositionPayment?.totalCheckOrWireAmount !== null &&  assetDetails?.dispositionPayment?.totalCheckOrWireAmount !== undefined) ? formatPriceWithSign(assetDetails?.dispositionPayment?.totalCheckOrWireAmount, 2) : '',
        allocatedAmount: (assetDetails?.dispositionPayment?.allocatedAmount !== null && assetDetails?.dispositionPayment?.allocatedAmount !== undefined) ? formatPriceWithSign(assetDetails?.dispositionPayment?.allocatedAmount, 2) : ''
      })
    }
  }, [assetDetails])

    useEffect(() => {
     if(fleetDispositionValue?.response){
      setSaveFleetDisposition(null)
      dispatch(getFleetAssetChangeLog(fleetDispositionValue?.id));
     }
    },[fleetDispositionValue])

    useEffect(() => {
      const assignedToDropdown = assignTo?.map((item: any) => ({ label: item.text, key: item.value, ...item }));
      setAssignedToDropdownList(assignedToDropdown);
  }, [assignTo])

  const dismissAlert = () => setError(undefined);


      const hideDialog = () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
      };

      const backToHome = () => {
        dispatchNav("Home");
              dispatchHeaderNav('Home');
              navigate('/ordermanagement');
              setPopupcontent({ ...Popupcontent, isDialogVisible: false })
      }

      const handleClickCancel = () => {
      if(assetOrderHeaderDetail?.orderStatus !== CONSTANTS?.ORDER_STATUS?.COMPLETED){ 
        let decriptionTxt = (
          <>
              <p>If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?</p>
          </>
      );

      setPopupcontent({
          ...Popupcontent,
          titleImg: ConfirmationBee,
          title: "UNSAVED CHANGES",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: decriptionTxt,
          outlineBtnText: "No",
          primaryBtnText: "Yes",
          isSingleConfirmationBtn: false,
          popupOutlinebtnOnclick: () => {
              setPopupcontent({ ...Popupcontent, isDialogVisible: false })
          },
          popupPrimarybtnOnclick: () => {
            backToHome()
          }
      });
      }else{
      backToHome()
      }};

      const [PopupcontentComplete, setPopupcontentComplete] = useState<any>(popupInitialData);

      const hideDialogComplete = () => {
        setPopupcontentComplete({ ...PopupcontentComplete, isDialogVisible: false })
      };

      const popupOutlinebtnOnclickComplete = () => {
        hideDialogComplete();
      };

  const isTitleExistOnChange = (e?: any, item?: any) => {
    let assetOrderDetailsTemp = transferData;
    assetOrderDetailsTemp?.map((request: any, index: any) => {
      request?.fleetAssetDetails?.map((itemLevel: any) => {
        if (itemLevel?.fleetRequestDetailId === assetDetails?.fleetRequestDetailId) {
          itemLevel.titleExists = item;
          setTitleExists({fleetDetailId : assetDetails?.fleetRequestDetailId, titleExists: item});
          dispatch(setTransferData(assetOrderDetailsTemp))
        }
      })
    })
  }
   
    const showReturnToRequestorBtn = (status?: any, fleetId?: any, isAlreadyReturnedFromFleet?: any) => {
      if (assetOrderHeaderDetail?.orderRequestType === CONSTANTS.TRANSFER)
        return false;
      let val = savedStatus?.filter(
        (savedItem?: any) => savedItem?.fleetItemId === fleetId
      );
      let savedVal: any;
      if (val?.length) {
        savedVal = val[0];
      }
      if (
        isAuthorized(FLEET_PROCESSING_PERMISSIONS.RETURN_TO_REQUESTOR) &&
        savedVal?.fleetStatus !== CONSTANTS.ORDER_STATUS.CANCELLED &&
        status !== CONSTANTS.ORDER_STATUS.CANCELLED &&
        savedVal?.fleetStatus !==
          CONSTANTS?.ORDER_STATUS?.REACTIVATION_COMPLETE &&
        status !== CONSTANTS?.ORDER_STATUS?.REACTIVATION_COMPLETE &&
        savedVal?.fleetStatus !== CONSTANTS?.ITEM_STATUS.DISPOSITION_COMPLETE &&
        status !== CONSTANTS?.ITEM_STATUS.DISPOSITION_COMPLETE &&
        savedVal?.fleetStatus !== CONSTANTS?.ITEM_STATUS.AFE_COMPLETE &&
        status !== CONSTANTS?.ITEM_STATUS.AFE_COMPLETE && !isAlreadyReturnedFromFleet
      ) {
        return true;
      } else {
        return false;
      }
    };

      const showCancelBtn = (status?: any, fleetId?: any) => {
        let val = savedStatus?.filter((savedItem?: any) => savedItem?.fleetItemId === fleetId)
        let savedVal: any
        if (val?.length) {
          savedVal = val[0]
        }
        if (isAuthorized(permissions.DeletePurchaseOrder) && 
        status !== CONSTANTS?.ORDER_STATUS?.TRANSFER_COMPLETE && 
        status !== CONSTANTS.ORDER_STATUS.CANCELLED && 
        savedVal?.fleetStatus !== CONSTANTS?.ORDER_STATUS?.TRANSFER_COMPLETE && 
        savedVal?.fleetStatus !== CONSTANTS?.ORDER_STATUS?.REACTIVATION_COMPLETE && 
        status !== CONSTANTS?.ORDER_STATUS?.REACTIVATION_COMPLETE && 
        savedVal?.fleetStatus !== CONSTANTS?.ITEM_STATUS.DISPOSITION_COMPLETE && 
        status !== CONSTANTS?.ITEM_STATUS.DISPOSITION_COMPLETE && 
        status !== CONSTANTS?.ORDER_STATUS?.AFE_COMPLETE && 
        savedVal?.fleetStatus !== CONSTANTS?.ORDER_STATUS?.AFE_COMPLETE) {
          return true
        } else {
          return false
        }
      }

      const setPopup = (
        type?: any,
        id?: any,
        userDetails?: any,
        dispatch?: any,
        setPopupcontent?: any,
        setCancelComments?: any
      ) => {
        const isCancel = type === "cancel";

        const descriptionTxt = (
          <>
            <p>
              {isCancel
                ? "Are you sure you want to cancel this item?"
                : "Please provide a comment before returning order request to the requestor"}
            </p>
          </>
        );

        const title = isCancel ? "CONFIRMATION" : "RETURN ORDER TO REQUESTOR";
        const primaryBtnText = isCancel ? "Yes" : "Return";
        const outlineBtnText = isCancel ? "No" : "Cancel";
        const titleImg = isCancel ? ConfirmationBee : CommentBee;

        const popupPrimarybtnOnclick = (
          item: any,
          comment: any,
          actionby: any,
          value: any
        ) => {
          const val = {
            orderId : parseInt(assetDetails?.orderRequestId),
            fleetDetailId: parseInt(id),
            savedBy: userDetails?.emailId,
            comments: comment,
            isBOS: assetOrderHeaderDetail?.bosAttachment?.attachmentUrl?.length ? true : false
          };
          if (isCancel) {
            setCancelComments(comment);
            dispatch(setSavedStatus([]));
            assetOrderHeaderDetail?.orderRequestType === CONSTANTS.AFEREQUEST ? dispatch(getAfeFleetItemCancel(val)) : dispatch(getAssetFleetItemCancel(val))
          } else {
            assetOrderHeaderDetail?.orderRequestType === CONSTANTS.AFEREQUEST ? dispatch(getAfeFleetItemReturnToRequestor(val)) : dispatch(getAssetFleetItemReturnToRequestor(val));
          }
          setPopupcontent((prev: any) => ({ ...prev, isDialogVisible: false }));
        };

        setPopupcontent((prev: any) => ({
          ...prev,
          titleImg: titleImg,
          title: title,
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: descriptionTxt,
          primaryBtnText: primaryBtnText,
          outlineBtnText: outlineBtnText,
          isCommentboxVisible: true,
          isCommentBoxRequire: true,
          isSingleConfirmationBtn: false,
          popupOutlinebtnOnclick: () => {
            setPopupcontent((prev: any) => ({
              ...prev,
              isDialogVisible: false,
            }));
            if (isCancel) setCancelComments("");
          },
          popupPrimarybtnOnclick: popupPrimarybtnOnclick,
        }));
      };

      const OnClickCancelItem = (e?: any, id?: any) => {
        e.preventDefault();
        setPopup(
          "cancel",
          id,
          userDetails,
          dispatch,
          setPopupcontent,
          setCancelComments
        );
      };

      const handleClickReturnToRequestor = (e?: any, id?: any) => {
        e.preventDefault();
        e.stopPropagation();
        setPopup("return", id, userDetails, dispatch, setPopupcontent);
      };

      const onAssignedToChange = (e?: any, val?: any) => {        
        if(e?.label?.length){
            if(assignedToError?.length){
            assignedToError?.map((assignItem: any, assignIndex?: any) => {
               if(assignItem?.fleetId === assetDetails?.fleetRequestDetailId){
                assignedToError.splice(assignIndex,1)
               }
            }) 
            setAssignedToError(assignedToError)
        }
        }
        const assetOrderDetailsData = transferData?.map((request: any, index: any) => {
            const fleetAssetDetails = request?.fleetAssetDetails?.map((itemLevel: any) => {
                if(itemLevel?.fleetRequestDetailId === assetDetails?.fleetRequestDetailId){
                    itemLevel.assignedTo = e?.key;
                    itemLevel.dispositionPayment = dispositionPaymentData?.length ? dispositionPaymentData?.find((data: any) => data?.fleetRequestTransDispoReactivationDetailId === itemLevel?.fleetRequestDetailId)?.dispositionPayment : {
                      isCheck: true,
                      checkOrWireNo: '',
                      buyerName: '',
                      totalCheckOrWireAmount: '',
                      allocatedAmount: '',
                    };
                    itemLevel.dispositionTitle = dispositionPaymentData?.length ? dispositionPaymentData?.find((data: any) => data?.fleetRequestTransDispoReactivationDetailId === itemLevel?.fleetRequestDetailId)?.dispositionTitle : {
                      requestedTitle: '',
                      receivedTitle: '',
                      shippedTitle: '',
                      trackingNo: '',
                    };
                  setAssignedToValue({
                    fleetDetailId: assetDetails?.fleetRequestDetailId,
                    assignedToName: e?.key
                  })
                }
                return {...itemLevel};
            })
            return {...request,fleetAssetDetails};
        })
        dispatch(setTransferData(assetOrderDetailsData))
      }

      const assignedToSelectedVal = (assignto ?: any) => {
        let val =  assignTo?.find(
          (x: any) => x?.value?.toLowerCase() === assignto?.toLowerCase()
        );
        return ({label: val?.text, value: val?.text })
      }

  const handlePaymentSectionChange = (e: any) => {
    setIsChnagedOccuredFlag(true)
    let name = e?.target?.name
    setError((prev: any) => ({ ...prev, [name]: '' }))
    if (name === 'checkOrWireNo' && e?.target?.value?.length > 50) {
      setError((prev: any) => ({ ...prev, checkOrWireNo: 'Please provide Payment description less than 50 characters'}))
    } else if (name === 'buyerName' && e?.target?.value?.length > 50) {
      setError((prev: any) => ({ ...prev, buyerName: 'Please provide Buyer name less than 50 characters' }))
    } else if (name === 'allocatedAmount' && e?.target?.value?.length > 30) {
      setError((prev: any) => ({ ...prev, allocatedAmount: 'Please provide Allocated amount less than 30 characters' }))
    } else if (name === 'checkOrWireNo' && !e?.target?.value) {
      setError((prev: any) => ({ ...prev, checkOrWireNo: 'Please provide Payment description' }))
    } else if (name === 'buyerName' && !e?.target?.value) {
      setError((prev: any) => ({ ...prev, buyerName: 'Please provide Buyer name' }))
    } else if (name === 'allocatedAmount' && !e?.target?.value) {
      setError((prev: any) => ({ ...prev, allocatedAmount: 'Please provide Allocated amount' }))
    }

    const tempPaymentData = JSON.parse(JSON.stringify(dispositionPaymentData))?.map((item: any) => {
      if (item?.fleetRequestTransDispoReactivationDetailId === parseInt(assetDetails?.fleetRequestDetailId)) {
        return {
          ...item,
          dispositionPayment: {
            ...item?.dispositionPayment,
            [name]: e?.target?.value
          },
          isChangesOcuured: true
        }
      } else {
        return item
      }
    })
    dispatch(setDispositionPaymentData(tempPaymentData))
    setDispositionPayment((prev: any) => ({ ...prev, [name]: e?.target?.value }))
  }

  const priceFormat = (e: any) => {
     setDispositionPayment((prev: any) => ({ ...prev, [e?.target?.name]: e?.target?.value ? formatPriceWithSign(e?.target?.value, 2) : ''}))
  }

  const handleDateChange = (date: any, fieldName: string, dateType: string) => {
    setIsChnagedOccuredFlag(true)
    if (date) {
      setDispositionTitle((prev: any) => ({ ...prev, [fieldName]: date }))
      setError((prev: any) => ({ ...prev, [fieldName]: '' }))
      const tempPaymentData = JSON.parse(JSON.stringify(dispositionPaymentData))?.map((item: any) => {
        if (item?.fleetRequestTransDispoReactivationDetailId === parseInt(assetDetails?.fleetRequestDetailId)) {
          return {
            ...item,
            dispositionTitle: {
              ...item?.dispositionTitle,
              [fieldName]: moment(date).format('MM/DD/YYYY').toString()
            },
            isChangesOcuured: true
          }
        } else {
          return item
        }
      })
      dispatch(setDispositionPaymentData(tempPaymentData))
    }
  }

  const handleTrackingNoChange = (e: any) => {
    setIsChnagedOccuredFlag(true)
    if (e?.target?.value?.length > 100) {
      setError((prev: any) => ({ ...prev, trackingNo: 'Please provide Title tracking # less than 100 characters' }))
    } else {
      setError((prev: any) => ({ ...prev, trackingNo: '' }))
    }
    setDispositionTitle((prev: any) => ({ ...prev, trackingNo: e?.target?.value }))
    const tempPaymentData = JSON.parse(JSON.stringify(dispositionPaymentData))?.map((item: any) => {
      if (item?.fleetRequestTransDispoReactivationDetailId === parseInt(assetDetails?.fleetRequestDetailId)) {
        return {
          ...item,
          dispositionTitle: {
            ...item?.dispositionTitle,
            trackingNo: e?.target?.value
          },
          isChangesOcuured: true
        }
      } else {
        return item
      }
    })
    dispatch(setDispositionPaymentData(tempPaymentData))
  }

  const validatePaymentDetails = () => {
    let isValid = true
    if (!!dispositionPayment?.checkOrWireNo &&
      !!dispositionPayment?.buyerName &&
      !!dispositionPayment?.allocatedAmount
    ) {
      if (dispositionPayment?.checkOrWireNo?.length > 50) {
        isValid = false
        setError((prev: any) => ({ ...prev, checkOrWireNo: 'Please provide Payment description less than 50 characters'}))
      }
      if (dispositionPayment?.buyerName?.length > 50) {
        isValid = false
        setError((prev: any) => ({ ...prev, buyerName: 'Please provide Buyer name less than 50 characters' }))
      }
      if (dispositionPayment?.allocatedAmount?.length > 30) {
        isValid = false
        setError((prev: any) => ({ ...prev, allocatedAmount: 'Please provide Allocated amount less than 30 characters' }))
      }
    } else {
      if (!dispositionPayment?.checkOrWireNo) {
        isValid = false
        setError((prev: any) => ({ ...prev, checkOrWireNo: 'Please provide Payment description' }))
      }
  
      if (!dispositionPayment?.buyerName) {
        isValid = false
        setError((prev: any) => ({ ...prev, buyerName: 'Please provide Buyer name' }))
      }

      if (!dispositionPayment?.allocatedAmount || dispositionPayment?.allocatedAmount === '0.00') {
        isValid = false
        setError((prev: any) => ({ ...prev, allocatedAmount: 'Please provide Allocated amount' }))
      }
    }

    return isValid
  }

  useEffect(()=>{
    if(validatePaymentInfo && showPaymentInformation){
      validatePaymentDetails();
    }
    setValidatePaymentInfo(false)
  }, [validatePaymentInfo])

  const handleSaveClick = (e?: any, methodType?: any) => {
    e.preventDefault();
    let isValidPayment = false;
    if(methodType == 'save'){
       isValidPayment = validatePaymentDetails() 
    }else{
      const tempPaymentData = JSON.parse(JSON.stringify(dispositionPaymentData))?.map((paymentitem: any)=>{
        if(paymentitem?.fleetRequestTransDispoReactivationDetailId === parseInt(assetDetails?.fleetRequestDetailId)){
          return {
            ...paymentitem,
            dispositionPayment: {
              isCheck: true,
              checkOrWireNo: 0,
              buyerName: "",
              totalCheckOrWireAmount: 0,
              allocatedAmount: 0
              }
          } 
          } 
      })
      dispatch(setDispositionPaymentData(tempPaymentData))
    }

    if(showPaymentInformation && (isValidPayment || methodType == 'clear')){
      let payload = {
        fleetRequestTransDispoReactivationDetailId: parseInt(assetDetails?.fleetRequestDetailId),
        dispositionPayment: {
          isCheck: methodType == 'clear' ? true : dispositionPayment?.isCheck,
          checkOrWireNo: methodType == 'clear' ? "" : dispositionPayment?.checkOrWireNo,
          buyerName: methodType == 'clear' ? '' : dispositionPayment?.buyerName,
          totalCheckOrWireAmount: methodType == 'clear' ? 0 : parseFloat(getOnlyNumbersWithSign(dispositionPayment?.totalCheckOrWireAmount)),
          allocatedAmount: methodType == 'clear' ? 0 : parseFloat(getOnlyNumbersWithSign(dispositionPayment?.allocatedAmount))
        },
        dispositionTitle: {
          requestedTitle: null,
          receivedTitle:null,
          shippedTitle: null,
          trackingNo: ''
        },
        savedBy:  userDetails?.emailId
      }
      dispatch(setFleetItemId(props?.item?.assetNo))
      dispatch(saveDispositionPayment([payload]))
      setIsChnagedOccuredFlag(false)
      return
    }
    return
  }

  const handleClearDate = (fieldName?: any) => {
    setIsChnagedOccuredFlag(true)
      setDispositionTitle((prev: any) => ({ ...prev, [fieldName]: null }))
      setError((prev: any) => ({ ...prev, [fieldName]: '' }))
      const tempPaymentData = JSON.parse(JSON.stringify(dispositionPaymentData))?.map((item: any) => {
        if (item?.fleetRequestTransDispoReactivationDetailId === parseInt(assetDetails?.fleetRequestDetailId)) {
          return {
            ...item,
            dispositionTitle: {
              ...item?.dispositionTitle,
              [fieldName]: null
            },
            isChangesOcuured: true
          }
        } else {
          return item
        }
      })
      dispatch(setDispositionPaymentData(tempPaymentData))
  }

    return(
        <LeasedOwnedTaskStepper
            StepperRef={StepperRef}
            Popupcontent={Popupcontent}
            hideDialog={hideDialog}
            handleClickCancel={handleClickCancel}
            assetOrderHeaderDetail={ props?.assetOrderHeaderDetail}
            PopupcontentComplete={PopupcontentComplete}
            hideDialogComplete={hideDialogComplete}
            popupOutlinebtnOnclickComplete={popupOutlinebtnOnclickComplete}
            item = {props?.item}
            setAssignedToError = {setAssignedToError}
            setAttachmentChangeFleetId = {setAttachmentChangeFleetId}
            attachmentChangeFleetId = {attachmentChangeFleetId}
            requestFleetAssetDetails = {requestFleetAssetDetails}
            assignedToError = {assignedToError}
            newAssetError = {newAssetError}
            setNewAssetError = {setNewAssetError}
            setAssetDeterminationValue = {setAssetDeterminationValue}
            assetDeterminationValue = {assetDeterminationValue}
            setNewAssetValue = {setNewAssetValue}
            newAssetValue = {newAssetValue}
            isTitleExistOnChange = {isTitleExistOnChange}
            assetDetails = {assetDetails}
            savedStatus = {savedStatus}
            error = {error}
            dismissAlert = {dismissAlert}
            showCancelBtn = {showCancelBtn}
            OnClickCancelItem = {OnClickCancelItem}
            onAssignedToChange={onAssignedToChange}
            setAssignedToValue = {setAssignedToValue}
            assignedToValue = {assignedToValue}
            assignedToOptions={assignedToDropdownList}
            assignedToSelectedVal = {assignedToSelectedVal}
            showPaymentInformation={showPaymentInformation}
            dispositionPayment={dispositionPayment}
            dispositionTitle={dispositionTitle}
            handlePaymentSectionChange={handlePaymentSectionChange}
            priceFormat={priceFormat}
            handleDateChange={handleDateChange}
            handleTrackingNoChange={handleTrackingNoChange}
            handleSaveClick={handleSaveClick}
            titleExists = {titleExists}
            setTitleExists = {setTitleExists}
            showReturnToRequestorBtn = {showReturnToRequestorBtn}
            handleClickReturnToRequestor = {handleClickReturnToRequestor}
            handleClearDate = {handleClearDate}
        />
    )
}

export default LeasedOwnedTaskStepperContainer;